(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var promo = document.querySelector('[data-ann-promo]');
    if (!promo) return;
    var end = Number(promo.getAttribute('data-ann-promo')) * 1000;
    var check = function () {
      if (Date.now() < end) return true;
      promo.remove();
      var normal = document.querySelector('[data-ann-normal]');
      if (normal) normal.removeAttribute('hidden');
      return false;
    };
    if (check()) {
      var t = setInterval(function () { if (!check()) clearInterval(t); }, 30000);
    }
  })();

  (function () {
    function init() {
      var bar = document.querySelector('[data-sale-bar]');
      if (!bar) return;
      var end = parseInt(bar.getAttribute('data-end'), 10) * 1000;
      var parts = {};
      bar.querySelectorAll('[data-part]').forEach(function (el) {
        parts[el.getAttribute('data-part')] = el;
      });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timer = null;

      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          bar.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        parts.d.textContent = Math.floor(left / 86400);
        parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((left % 3600) / 60));
        parts.s.textContent = pad(left % 60);
      }

      tick();
      timer = setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var panels = Array.from(root.querySelectorAll('[data-panel]'));
    var steps = Array.from(root.querySelectorAll('[data-step]'));
    var tabs = Array.from(root.querySelectorAll('[data-topic-tab]'));
    var demos = Array.from(root.querySelectorAll('[data-topic-demo]'));
    var topic = 'routines';
    var hasChosenTopic = false;
    var current = 0;
    var sceneTransition = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var controller = new AbortController();
    var signal = controller.signal;
    root.dataset.scrollJourney = 'true';
    root.journeyCleanup = function () { if (sceneTransition) sceneTransition.skipTransition(); controller.abort(); };
    function selectTopic(value) {
      if (!demos.some(function (demo) { return demo.dataset.topicDemo === value; })) return;
      topic = value;
      demos.forEach(function (demo) { demo.toggleAttribute('data-selected', demo.dataset.topicDemo === value); });
      tabs.forEach(function (tab) { tab.setAttribute('aria-pressed', String(tab.dataset.topicTab === value)); });
      var selectedTab = tabs.find(function (tab) { return tab.dataset.topicTab === value; });
      var recap = root.querySelector('[data-topic-recap]');
      if (recap && selectedTab) { recap.hidden = !hasChosenTopic; recap.querySelector('[data-recap-text]').textContent = selectedTab.textContent; }
    }
    function markScene(index) {
        current = index;
        panels.forEach(function (panel, i) { panel.toggleAttribute('data-active', i === index); });
        steps.forEach(function (step, i) { if (i === index) step.setAttribute('aria-current', 'step'); else step.removeAttribute('aria-current'); step.toggleAttribute('data-complete', i < index); });
        var counter = root.querySelector('[data-chapter-count]');
        var label = root.querySelector('[data-chapter-label]');
        if (counter) counter.textContent = '0' + (index + 1);
        if (label && steps[index]) label.textContent = steps[index].dataset.label;
        var previous = root.querySelector('[data-chapter-prev]');
        var next = root.querySelector('[data-chapter-next]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === panels.length - 1;
        root.dataset.scene = String(index);
        var mobileBuy = root.querySelector('[data-mobile-buy]');
        if (mobileBuy) mobileBuy.hidden = index === 0 || index === 3;
    }
    function show(index, focus) {
      index = Number(index);
      if (!panels[index]) return;
      if (bookDialog && bookDialog.open) bookDialog.close();
      if (root.dataset.scrollJourney) {
        markScene(index);
        if (focus) {
          panels[index].scrollIntoView({ block: 'start', behavior: reduced.matches ? 'instant' : 'smooth' });
          var targetHeading = panels[index].querySelector('[tabindex="-1"]');
          if (targetHeading) targetHeading.focus({ preventScroll: true });
        }
        return;
      }
      function updateScene() { markScene(index); }
      function focusScene() {
        if (!focus || current !== index || !root.isConnected) return;
        var heading = panels[index].querySelector('[tabindex="-1"]');
        if (heading) heading.focus({ preventScroll: true });
        var rect = root.getBoundingClientRect();
        if (rect.top < 30 || rect.top > 120) root.scrollIntoView({ block: 'start', behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      if (root.dataset.enhanced && index !== current && !reduced.matches && root.dataset.motion === 'true' && document.startViewTransition) {
        if (sceneTransition) sceneTransition.skipTransition();
        try {
          root.dataset.nativeTransition = 'true';
          var transition = document.startViewTransition(updateScene);
          sceneTransition = transition;
          transition.updateCallbackDone.then(focusScene).catch(function () {});
          transition.finished.then(function () { if (sceneTransition === transition) { sceneTransition = null; delete root.dataset.nativeTransition; } }).catch(function () {});
        } catch (error) { delete root.dataset.nativeTransition; updateScene(); focusScene(); }
      } else { updateScene(); focusScene(); }
    }
    selectTopic(topic);
    show(0, false);
    root.dataset.enhanced = 'true';
    var scrollFrame = 0;
    function syncScroll() {
      scrollFrame = 0;
      if (document.querySelector('dialog[open]')) return;
      var height = document.documentElement.clientHeight;
      var bounds = root.getBoundingClientRect();
      root.dataset.inView = String(bounds.bottom > 160 && bounds.top < height);
      var line = height * 0.42;
      var index = 0;
      panels.forEach(function (panel, i) { if (panel.getBoundingClientRect().top <= line) index = i; });
      if (index !== current) markScene(index);
    }
    function scheduleScroll() { if (!scrollFrame) scrollFrame = requestAnimationFrame(syncScroll); }
    window.addEventListener('scroll', scheduleScroll, { passive: true, signal: signal });
    window.addEventListener('resize', scheduleScroll, { passive: true, signal: signal });
    var scrollCleanup = root.journeyCleanup;
    root.journeyCleanup = function () { cancelAnimationFrame(scrollFrame); scrollCleanup(); };
    syncScroll();
    root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-topic-choice]');
      var go = event.target.closest('[data-go], [data-step]');
      var previous = event.target.closest('[data-chapter-prev]');
      var next = event.target.closest('[data-chapter-next]');
      if (previous) show(current - 1, true);
      if (next) show(current + 1, true);
      if (choice) { event.preventDefault(); hasChosenTopic = true; selectTopic(choice.dataset.topicChoice); show(2, true); }
      else if (go) { event.preventDefault(); show(go.dataset.go || go.dataset.step, true); }
      var tab = event.target.closest('[data-topic-tab]');
      if (tab) { hasChosenTopic = true; selectTopic(tab.dataset.topicTab); }
    }, { signal: signal });
    document.addEventListener('pointerdown', function () { if (sceneTransition) sceneTransition.skipTransition(); }, { capture: true, signal: signal });
    var bookDialog = root.querySelector('[data-book-dialog]');
    var bookOpener = null;
    function selectBook(number) {
      var selected = null;
      root.querySelectorAll('[data-book-detail]').forEach(function (detail) { detail.hidden = detail.dataset.bookDetail !== String(number); if (!detail.hidden) selected = detail; });
      root.querySelectorAll('[data-book-tab]').forEach(function (tab) { tab.setAttribute('aria-pressed', String(tab.dataset.bookTab === String(number))); if (bookDialog.open && tab.dataset.bookTab === String(number)) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced.matches ? 'instant' : 'smooth' }); });
      return selected;
    }
    if (bookDialog && typeof bookDialog.showModal === 'function') {
      root.querySelectorAll('[data-open-book]').forEach(function (button) {
        button.addEventListener('click', function () {
          bookOpener = button;
          var detail = selectBook(button.dataset.openBook);
          bookDialog.showModal();
          var activeTab = bookDialog.querySelector('[data-book-tab][aria-pressed="true"]');
          if (activeTab) activeTab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
          var heading = detail && detail.querySelector('h2');
          if (heading) heading.focus({ preventScroll: true });
        }, { signal: signal });
      });
      bookDialog.addEventListener('click', function (event) {
        if (event.target === bookDialog || event.target.closest('[data-close-book]')) bookDialog.close();
        var tab = event.target.closest('[data-book-tab]');
        if (tab) selectBook(tab.dataset.bookTab);
        var toggle = event.target.closest('[data-sample-toggle]');
        if (toggle) {
          var detail = toggle.closest('[data-book-detail]');
          var showSample = toggle.getAttribute('aria-pressed') !== 'true';
          detail.querySelector('[data-detail-cover]').hidden = showSample;
          detail.querySelector('[data-detail-sample]').hidden = !showSample;
          toggle.setAttribute('aria-pressed', String(showSample));
          toggle.textContent = showSample ? toggle.dataset.coverLabel : toggle.dataset.insideLabel;
        }
      }, { signal: signal });
      bookDialog.addEventListener('close', function () { if (current === 0 && bookOpener && bookOpener.offsetParent !== null) bookOpener.focus({ preventScroll: true }); }, { signal: signal });
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="#offer"]');
      if (!link || root.contains(link)) return;
      event.preventDefault();
      show(3, true);
    }, { signal: signal });
    var lightbox = root.querySelector('[data-journey-lightbox]');
    var opener = null;
    if (lightbox && typeof lightbox.showModal === 'function') {
      root.querySelectorAll('[data-enlarge]').forEach(function (button) {
        button.addEventListener('click', function () {
          opener = button;
          var source = button.querySelector('img');
          var image = lightbox.querySelector('img');
          image.src = source.src;
          image.alt = source.alt;
          lightbox.showModal();
        }, { signal: signal });
      });
      lightbox.addEventListener('click', function (event) { if (event.target === lightbox) lightbox.close(); }, { signal: signal });
      lightbox.addEventListener('close', function () { if (opener) opener.focus({ preventScroll: true }); }, { signal: signal });
    }
    root.querySelectorAll('[data-journey-buy] form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.sent) { event.preventDefault(); return; }
        form.dataset.sent = 'true';
        var button = form.querySelector('button[type="submit"]');
        if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('is-loading'); }
      }, { signal: signal });
    });
    window.addEventListener('pageshow', function () {
      root.querySelectorAll('[data-journey-buy] form').forEach(function (form) {
        delete form.dataset.sent;
        var button = form.querySelector('button[type="submit"]');
        if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('is-loading'); }
      });
    }, { signal: signal });
    var end = Number(root.dataset.end) * 1000;
    function expire() {
      root.querySelectorAll('[data-promo]').forEach(function (el) { el.hidden = true; });
      root.querySelectorAll('.journey__regular-label').forEach(function (el) { el.hidden = false; });
    }
    if (end) {
      var checkEnd = function () { if (Date.now() >= end) { expire(); clearInterval(timer); } };
      var timer = setInterval(checkEnd, 30000);
      checkEnd();
      var oldCleanup = root.journeyCleanup;
      root.journeyCleanup = function () { clearInterval(timer); oldCleanup(); };
    }
    document.addEventListener('shopify:block:select', function (event) {
      if (root.contains(event.target)) show(0, false);
    }, { signal: signal });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && end && Date.now() >= end) expire(); }, { signal: signal });
  }
  document.querySelectorAll('[data-journey]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-journey]').forEach(init); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-journey]').forEach(function (root) { if (root.journeyCleanup) root.journeyCleanup(); }); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mealtime-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sticky = document.querySelector('[data-mt-sticky]');
    var hero = document.getElementById('mt-hero');
    if (sticky && hero) {
      var update = function () {
        if (hero.getBoundingClientRect().bottom < 0) {
          sticky.removeAttribute('hidden');
        } else {
          sticky.setAttribute('hidden', '');
        }
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    var box = document.getElementById('mt-lightbox');
    if (box && typeof box.showModal === 'function') {
      var big = box.querySelector('.mt-lightbox__img');
      document.querySelectorAll('.mt-peek__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var img = btn.querySelector('img');
          big.src = btn.getAttribute('data-full');
          big.alt = img ? img.alt : '';
          box.showModal();
        });
      });
      box.addEventListener('click', function (e) {
        if (e.target === box) box.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playbook-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sticky = document.querySelector('[data-pl-sticky]');
    var hero = document.getElementById('pl-hero');
    if (sticky && hero) {
      var update = function () {
        if (hero.getBoundingClientRect().bottom < 0) {
          sticky.removeAttribute('hidden');
        } else {
          sticky.setAttribute('hidden', '');
        }
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    var box = document.getElementById('pl-lightbox');
    if (box && typeof box.showModal === 'function') {
      var big = box.querySelector('.pl-lightbox__img');
      document.querySelectorAll('.pl-peek__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var img = btn.querySelector('img');
          big.src = btn.getAttribute('data-full');
          big.alt = img ? img.alt : '';
          box.showModal();
        });
      });
      box.addEventListener('click', function (e) {
        if (e.target === box) box.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!this.track || this.thumbs.length === 0) return;

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goTo(index));
      });

      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        },
        { passive: true }
      );
    }

    goTo(index) {
      const slide = this.track.children[index];
      if (!slide) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  /*
   * Sticky buy bar: appears once the main buy box ([data-sticky-after]) has scrolled
   * above the screen, and hides while any [data-sticky-hide] element (final CTA, footer) is visible.
   * Uses scroll position rather than IntersectionObserver so it is also right after a reload
   * or an anchor jump that lands below the buy box.
   */
  (function () {
    function init() {
      var bar = document.querySelector('[data-sticky-bar]');
      var buyBox = document.querySelector('[data-sticky-after]');
      if (!bar || !buyBox) return;

      var hideTargets = document.querySelectorAll('[data-sticky-hide]');
      var frame = null;

      function update() {
        frame = null;
        var pastBuyBox = buyBox.getBoundingClientRect().bottom < 0;
        var covered = false;
        hideTargets.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) covered = true;
        });
        bar.classList.toggle('is-visible', pastBuyBox && !covered);
      }

      function schedule() {
        if (frame === null) frame = requestAnimationFrame(update);
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var bar = document.querySelector('[data-landing-sticky]');
      if (!bar) return;
      var hideTargets = document.querySelectorAll('[data-sticky-hide]');
      var frame = null;

      function update() {
        frame = null;
        var shown = window.scrollY > window.innerHeight * 0.9;
        hideTargets.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) shown = false;
        });
        bar.classList.toggle('is-visible', shown);
      }

      function schedule() {
        if (frame === null) frame = requestAnimationFrame(update);
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
